import ComboboxFilter from './combobox-editable';
import Select from './combobox-select';

export default class Combobox {
    constructor(elem) {
        //strip away jquery with the [0]
        this.combobox = elem[0];

        const options = new Map();
        [...this.combobox.querySelectorAll('[js-combobox-data] > option')].forEach(option =>
            options.set(option.value, option.text)
        );

        if (!options.size) return;
        if (this.combobox.getAttribute('js-combobox-filter') !== null) {
            return new ComboboxFilter(this.combobox, options).init();
        } else if (this.combobox.getAttribute('js-select') !== null) {
            return new Select(this.combobox, [...options]).init();
        }
    }
}